var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('page-title',{attrs:{"overlay":"","background":_vm.bgImg,"title":"Servicios"}}),_c('course-listing',{staticClass:"pt-120 pb-120"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }